import {
    ForwardRefRenderFunction,
    forwardRef,
    InputHTMLAttributes,
} from "react";
import { DeepMap, FieldError } from "react-hook-form";
import CurrencyInput from "react-currency-input-field";
import Label from "../input-label/InputLabel";
import ErrorMessage from "components/atoms/error-message/ErrorMessage";
import Button from "components/atoms/button/Button";
import Icon from "components/atoms/icon/Icon";
import { IconType } from "lib/helpers/constants/iconTypes";

type TypeInputClass = {
    container?: string;
    icon?: string;
    label?: string;
    fillcolor?: string;
    errorClassName?: string;
};

export interface ICurrencyInputFieldProps
    extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
    error?: DeepMap<any, FieldError>;
    label?: string;
    icon?: IconType;
    childrenIcon?: IconType;
    toggleGeneratePassword?: () => void;
    toggleShowPassowrd?: () => void;
    classes?: Partial<TypeInputClass>;
    value?: string | number;
    onValueChange?: (value: string | undefined) => void;
}

const CurrencyInputField: ForwardRefRenderFunction<
    HTMLInputElement,
    ICurrencyInputFieldProps
> = (
    {
        toggleShowPassowrd,
        toggleGeneratePassword,
        classes = {
            errorClassName: "",
            container: "",
            icon: "",
            label: "",
            fillcolor: "",
        },
        error,
        childrenIcon,
        label,
        icon,
        onValueChange,
        value,
        ...rest
    },
    ref
) => {
        const { defaultValue, step, ...safeRest } = rest;
        return (
            <div className={`relative ${classes?.container}`}>
                {label && <Label text={label} className={classes.label} />}

                <CurrencyInput
                    ref={ref}
                    decimalsLimit={2}
                    decimalSeparator="."
                    groupSeparator="`"
                    allowNegativeValue={true}
                    value={value}
                    onValueChange={onValueChange}
                    {...safeRest}
                    className={`border-[1px] border-inputborder rounded-[8px] h-[41px] 2xl:h-[46px] w-full p-[7px] 2xl:p-[10px] outline-0 indent-2 placeholder-[#667085] font-inter-regular ${rest.className}`}
                />

                <ErrorMessage error={error} className={classes.errorClassName} />

                {icon && (
                    <Button type="button" className="button" onClick={toggleShowPassowrd}>
                        <Icon
                            iconType={icon}
                            className={`absolute right-3 bg-white top-[55%] cursor-pointer transform -translate-y-1/1 ${classes?.icon}`}
                            color={classes?.fillcolor}
                        />
                    </Button>
                )}

                {childrenIcon && (
                    <Button
                        type="button"
                        className="button"
                        onClick={toggleGeneratePassword}
                    >
                        <Icon
                            iconType={childrenIcon}
                            className={`absolute bg-white cursor-pointer right-[40px] top-[55%] transform -translate-y-1/1 ${classes?.icon}`}
                            color={classes?.fillcolor}
                        />
                    </Button>
                )}
            </div>
        );
    };

export default forwardRef(CurrencyInputField);
